import { render, staticRenderFns } from "./toggleSwitch2.vue?vue&type=template&id=524f8c24&scoped=true&"
import script from "./toggleSwitch2.vue?vue&type=script&lang=js&"
export * from "./toggleSwitch2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524f8c24",
  null
  
)

export default component.exports